import styled from 'styled-components';

const BulletList = styled.ul`
  list-style-type: disc;
  padding-left: 1.5rem;
`;

export default BulletList;
